<template>
  <div class="login-area">
    <div class="d-table">
      <div class="d-table-cell">
        <div class="container">
          <div class="form-row">
            <div class="offset-sm-3 col-sm-6">
              <div class="login-form">
                <div class="logo">
                  <a href>
                    <img src="@/assets/img/nextpay-logo.svg" alt="image" />
                  </a>
                </div>
                <div class="form-head">
                  <h1 for>Đăng nhập</h1>
                </div>
                <ValidationObserver ref="observer">
                  <form slot-scope="{ validate }">
                    <ValidationProvider rules="required|mail" vid="email" name="Email">
                      <b-form-group slot-scope="{ errors }" label="Email">
                        <!-- <b-form-input
                          type="email"
                          v-on:keyup.enter="validate().then(makeLogin)"
                          v-model="email"
                          :state="errors[0] ? false : (valid ? true : null)"
                        ></b-form-input> -->
                        <b-form-input
                          type="email"
                          v-on:keyup.enter="validate().then(makeLogin)"
                          v-model="email"
                          :state="errors[0] ? false : null"
                        ></b-form-input>
                        <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                      </b-form-group>
                    </ValidationProvider>
                    <ValidationProvider rules="required" name="Password">
                      <b-form-group slot-scope="{ errors }" label="Mật khẩu">
                        <b-form-input
                          type="password"
                          v-on:keyup.enter="validate().then(makeLogin)"
                          v-model="password"
                          :state="errors[0] ? false : null"
                        ></b-form-input>
                        <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                      </b-form-group>
                    </ValidationProvider>
                    <p class="text-danger" v-show="errorMessage">
                      <i class="bx bx-error-alt"></i> {{ errorMessage }}
                    </p>
                    <ul class="form-btn form-row m-t-20">
                      <li class="col-12">
                        <a
                          class="btn btn-success w-100 text-white"
                          @click="validate().then(makeLogin)"
                          >Đăng nhập</a
                        >
                      </li>
                      <li class="col-12 mt-2">
                        <a class="btn btn-primary w-100 text-white" @click="loginSso"
                          >Đăng nhập SSO</a
                        >
                      </li>
                      <!-- <li class="col-6">
                        <p class="mb-0 m-t-10 text-right">
                          <a href="#" class="color-1564a9 p-0 text-transform-none">Quên mật khẩu?</a>
                        </p>
                      </li> -->
                    </ul>
                  </form>
                </ValidationObserver>
              </div>
              <!-- <p class="text-footer">
                Hotline:
                <a href="calto:1900 2079">1900 2079</a> - Email:
                <a href="mailto:support@nextinvoice.vn">support@nextinvoice.vn</a>
              </p> -->
            </div>
          </div>
        </div>
      </div>
    </div>

    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>

<script>
  import { AuthService } from '@/services/auth.service'
  import keyStore from '@/constant/storeKey'
  // import { getToken } from 'firebase/messaging';
  // import { messaging } from '@/config/firebaseConfig'
  import * as Sentry from '@sentry/vue'

  export default {
    name: 'Login',
    data: () => {
      return {
        smallWindow: null,
        email: '',
        password: '',
        errorMessage: null,
        showLoading: false,
        tokenFirebase: '',
      }
    },
    beforeDestroy() {
      window.removeEventListener('message', this.handleMessage)
    },
    created() {
      // eslint-disable-next-line eqeqeq
      const platform = localStorage.getItem('platform')
      if (platform == null) {
        this.getTokenFirebase()
      }
      if (this.$route.query.nosso != 1) this.loginSso()
    },

    mounted() {
      if ('serviceWorker' in navigator) {
        window.callbackNotificationToken = token => {
          this.tokenFirebase = token
        }

        const script = document.createElement('script')
        script.type = 'module'
        script.src = '/firebase-notification.js'

        // Xử lý callback khi script load xong
        script.onload = function () {
          console.log('Load script firebase done')
        }

        document.head.appendChild(script)
      } else {
        console.log('Service Worker is not supported in this browser.')
      }
    },

    methods: {
      async loginSso() {
        const ssoConfigRes = await AuthService.getSsoConfig()
        const ssoConfig = ssoConfigRes.data ?? {}
        this.smallWindow = window.open(
          `${ssoConfig.domain}/login?portal=${ssoConfig.portal}&relogin=${ssoConfig.reLogin}&callback=${window.location.origin}/default?channel=WEB`,
          'smallWindow',
          'width=400,height=500,location=no'
        )
        if (!this.smallWindow) {
          alert('The popup was blocked. Please allow popups for this site.')
        } else {
          window.addEventListener('message', this.handleMessage)
        }
      },
      handleMessage(event) {
        try {
          if (event.source === this.smallWindow) {
            if (event.data === 'smallWindowDone') {
              this.smallWindow.close()
            } else {
              this.showFailMx(event.data)
              this.smallWindow.close()
              setTimeout(async () => {
                const ssoConfigRes = await AuthService.getSsoConfig()
                const ssoConfig = ssoConfigRes.data ?? {}
                window.location.href = `${ssoConfig.domain}/logout?portal=${ssoConfig.portal}&logoutAll=false&callback=${window.location.origin}/login?nosso=1`
              }, 1000)
            }
          }
        } catch (error) {}
      },
      async makeLogin() {
        try {
          const isSuccess = await this.$refs.observer.validate()
          if (!isSuccess) return
          this.showLoading = true
          const res = await AuthService.makeLogin({
            email: this.email,
            password: this.password,
            webNotificationToken: this.tokenFirebase,
          })
          const userInfo = res.data?.data
          if (userInfo) {
            Sentry.setUser({
              id: userInfo.id,
              username: userInfo.username,
            })
          }
          localStorage.setItem(keyStore.IS_LOGIN_SSO, 'false')
          localStorage.setItem('system-notify', 'true')
          try {
            this.smallWindow && this.smallWindow.close()
          } catch (error) {}
          this.errorMessage = null
          this.$root.loading = true
          this.$router
            .push({ path: this.$route.query.redirectTo ? this.$route.query.redirectTo : '/' })
            .catch(() => {
              this.$root.loading = false
              this.errorMessage = 'Hệ thống đang được bảo trì. Vui lòng thử lại sau'
            })
        } catch (error) {
          this.errorMessage = error.message
        } finally {
          this.showLoading = false
        }
      },
      getTokenFirebase() {
        // if (!("Notification" in window)) { return false }
        // if (Notification.permission === "granted") {
        //   if ('serviceWorker' in navigator) {
        //     navigator.serviceWorker.register('/firebase-messaging-sw.js')
        //     .then((registration) => {
        //       console.log('Registered Firebase Success:', registration.scope);
        //       const key_pair = (window._env_?.VUE_APP_FIREBASE_KEY_PAIR ?? process.env.VUE_APP_FIREBASE_KEY_PAIR)
        //       getToken(messaging, { vapidKey: key_pair }).then(tokenFirebase => {
        //         if (tokenFirebase) {
        //           this.tokenFirebase = tokenFirebase
        //           localStorage.setItem('tokenFirebase', tokenFirebase)
        //         } else {
        //           console.log('No Registration Token Firebase Available. Request Permission To Generate One.');
        //         }
        //       }).catch(err => {
        //         console.error('An Error Occurred While Retrieving Token Firebase. ', err);
        //       })
        //     }).catch((err) => {
        //       console.log('Registered Firebase Failed:', err);
        //     });
        //   }
        // } else {
        //   Notification.requestPermission()
        // }
      },
    },
  }
</script>
